import LandingPageBackground from "./LandingPageBackground";

export default LandingPageBackground;
